import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from "@angular/common";

@Pipe({
  name: 'displayDate'
})
export class DisplayDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {
  }
  transform(value: unknown, key: string, dateColumn: string[]) {
    if(dateColumn.includes(key)) {
      return this.datePipe.transform(value, 'MM/dd/yyyy')
    }
    return value;
  }
}
